import React from 'react';
import { SocietyProviderFilters } from '../../../app/models/SocietyProvider';
import ButtonSearchFilter from '../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: SocietyProviderFilters;
    setFilter: (filter: SocietyProviderFilters) => void;
    onSearch: () => void;
};

const ProviderFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="origin">
                            Rut
                        </label>
                        <input
                            title="Rut"
                            type="text"
                            id="rut"
                            name="rut"
                            className="form-control form-control-sm"
                            value={filter.rut}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="business_name">
                            Razon Social
                        </label>
                        <input
                            title="Razon Social"
                            type="text"
                            id="business_name"
                            name="business_name"
                            className="form-control form-control-sm"
                            value={filter.business_name}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="fantasy_name">
                            Nombre fantasía
                        </label>
                        <input
                            title="Razon Social"
                            type="text"
                            id="fantasy_name"
                            name="fantasy_name"
                            className="form-control form-control-sm"
                            value={filter.fantasy_name}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className='col-md-auto'>
                    <div style={{marginTop: '22px'}}>
                        <ButtonSearchFilter callbackSearch={onSearch}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProviderFilter;
